import React from "react"

import { QidDatapoint } from "server/models"
import { Table } from "client/components"
import { QidResultType } from "client/store"

import { DatapointWrapper } from "client/pages/qid/product/results/styled"
import Columns from "./columns"

interface DatapointProps {
    datapoint: QidDatapoint
    datapointAvg: QidResultType
    onClick: () => void // onSelect event for datapoint
}

const Datapoint = ({
    datapoint,
    datapointAvg,
    onClick,
}: DatapointProps) => {
    const ids: number[] = [0, datapoint.id]
    const list: { [id: number]: QidDatapoint | QidResultType } = {
        0: datapointAvg,
        [datapoint.id]: datapoint,
    }
    datapoint.datapoints.forEach((nested) => {
        ids.push(nested.id)
        list[nested.id] = nested
    })

    const columns = Columns()
    return (
        <DatapointWrapper onClick={onClick}>
            <Table
                columns={columns}
                dataList={list}
                dataIds={ids}
                rowSize="sm"
                showPagination={false}
                showBottom={false}
            />
        </DatapointWrapper>
    )
}
export default Datapoint
